import { render, staticRenderFns } from "./TransferPage.vue?vue&type=template&id=9925352c&scoped=true"
import script from "./TransferPage.vue?vue&type=script&lang=js"
export * from "./TransferPage.vue?vue&type=script&lang=js"
import style0 from "./TransferPage.vue?vue&type=style&index=0&id=9925352c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9925352c",
  null
  
)

export default component.exports